<template>
    <div class="careers-wrapper">
      <app-header></app-header>
      <div class="careers-content">
        <app-aside :linksArray="links"></app-aside>
        <div class="careers-content-main">
          <app-career v-if="this.$route.params.page == 'career'"></app-career>
          <app-open-positions v-if="this.$route.params.page == 'open-positions'"></app-open-positions>
          <app-internships v-if="this.$route.params.page == 'internships'"></app-internships>
          <!-- <app-application-form v-if="this.$route.params.page == 'application-form'"></app-application-form> -->
        </div>
      </div>
    </div>
</template>

<script>
import Header from "./careers/Header";
import Aside from "./shared/Aside";
import Career from "./careers/Career";
import OpenPositions from "./careers/OpenPositions";
import Internships from "./careers/Internships";
//import ApplicationForm from "./careers/ApplicationForm";

export default {
  components: {
    appHeader: Header,
    appAside: Aside,
    appCareer: Career,
    appOpenPositions: OpenPositions,
    appInternships: Internships
    //appApplicationForm: ApplicationForm
  },
  data() {
    return {
      links: [
        { name: "Una Carriera in Alcomet", url: "/careers/career" },
        { name: "Posizioni disponibili", url: "/careers/open-positions"  },
        { name: "Tirocini", url: "/careers/internships" },
        //{ name: "Modulo di domanda", url: "/careers/application-form" }
      ]
    };
  },
  watch: {
    $route(to, from) {
      //      this.isPageExisting();
    }
  },
  methods: {
    // isPageExisting() {
    //   switch (this.$route.params.page) {
    //     case "environment":
    //       break;
    //     default:
    //       this.$router.replace("../404");
    //   }
    // }
  },
  mounted() {
    //    this.isPageExisting();
  }
};
</script>

<style scoped>
.careers-content {
  display: flex;
}
.careers-content-main {
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .careers-content-main {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Careers.vue